import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { CLEAR_WEATHER_SYMBOL } from "@poscon/shared-types";
import { useWindowSize } from "usehooks-ts";
import { trackCoordinationDataSelector, trackFromFpIdSelector, useRootSelector, } from "../stateSelectors.js";
import { eramTextDimensionMap } from "../../eramFont.js";
import { EramInput, useInputProps } from "./EramInput.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { MenuElement } from "./MenuElement.js";
import { colorNameMap } from "../../colorNameMap.js";
import { useDispatchCommand } from "../contexts/commonContext";
import { isValid4thLineCharacter, stringToParsedTokenArray } from "@poscon/shared-types/eram";
const { width: fontWidth, height: fontHeight } = eramTextDimensionMap[2];
const width = 10 * fontWidth;
const xX = width - fontHeight;
const labelWidth = xX;
export const FreeTextMenu = ({ fp, pos, startDrag, closeMenu, zIndex, eventMode, ref, }) => {
    const fpId = fp.id;
    const windowSize = useWindowSize();
    const dispatchCommand = useDispatchCommand();
    const track = useRootSelector((state) => trackFromFpIdSelector(state, fpId));
    const coordination = useRootSelector((state) => track ? trackCoordinationDataSelector(state, track.id) : null);
    const [showInvalid, setShowInvalid] = useState(false);
    const inputProps = useInputProps(`freeTextMenu/${fp.id}`, coordination?.freeformText ?? "", (s) => {
        if (s.length === 0 || s.length > 8 || s.split("").some((c) => !isValid4thLineCharacter(c))) {
            setShowInvalid(true);
            return;
        }
        dispatchCommand(stringToParsedTokenArray(`QS ${CLEAR_WEATHER_SYMBOL}${s} ${fp.cid ?? fp.callsign}`));
        closeMenu();
    }, {
        maxLength: 8,
        keyPredicate: isValid4thLineCharacter,
        onInvalidCharacterEntered: () => setShowInvalid(true),
    });
    const localRef = useRef(null);
    useCenterCursor(localRef);
    const height = (fontHeight + 1) * (showInvalid ? 4 : 3);
    const x = Math.min(pos.x, windowSize.width - width);
    const y = Math.min(pos.y, windowSize.height - (height + 1));
    return (_jsxs("container", { ref: ref, label: "FREETEXT_MENU", x: x, y: y, sortableChildren: true, zIndex: zIndex, eventMode: eventMode, children: [_jsx(MenuElement, { x: 0, y: 0, width: labelWidth, text: fp.callsign, onmousedown: startDrag }), _jsx(MenuElement, { x: xX, y: 0, width: fontHeight, text: "X", onmousedown: closeMenu }), _jsx(MenuElement, { y: fontHeight + 1, width: width, fillColor: 0, highlightOnHover: true, children: _jsx(EramInput, { ...inputProps, width: width - 4, x: 2, y: 1, tint: colorNameMap.lightGrey }) }), _jsx(MenuElement, { y: (fontHeight + 1) * 2, width: width, ref: localRef, text: "DELETE", onmousedown: () => {
                    dispatchCommand(stringToParsedTokenArray(`QS * ${fp.cid ?? fp.callsign}`));
                    closeMenu();
                } }), showInvalid && (_jsx(MenuElement, { x: 0, y: (fontHeight + 1) * 3, width: width, text: "INVALID", tint: colorNameMap.yellow, fillColor: 0 }))] }));
};
//# sourceMappingURL=FreeTextMenu.js.map